function fn_layout_header() {
    var $fn = $("#layout_header"),
        $header = $fn.find(".elm_header");

    if ($fn.length) {
        $fn.after('<nav id="layout_nav" class="ssm-nav" role="presentation"><div class="elm_head"></div><div class="elm_content"></div></nav>');

        var $layout_nav = $(document).find("#layout_nav"),
            $logo = $header.find(".elm_logo").clone(),
            $nav = $header.find(".elm_nav").clone();

        $layout_nav.find(".elm_head").append($logo);
        $layout_nav.find(".elm_content").append($nav);

        $('.ssm-nav').slideAndSwipe();

        $fn.on("click","[data-nav-toggle]",function (e) {
            e.preventDefault();
            var $this = $(this),
                $menu = $this.siblings(".elm_nav"),
                $icon = $this.find(".elm_menu"),
                $text = $this.find(".elm_menu_desc");

            $menu.toggleClass("mod--active");
            $text.fadeToggle(500);
            $icon.toggleClass("icon--menu").toggleClass("icon--close");
            $header.toggleClass("mod--active");
        });

        $(window).scroll(function() {
            if ($(window).scrollTop() > 100){
                $header.addClass("mod--scrolled");
            }
            else {
                $header.removeClass("mod--scrolled");
            }
        });
    }
}